"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _customizr = require("./services/customizr");

var _errormessages = _interopRequireDefault(require("./helpers/errormessages"));

var _getucnid = _interopRequireDefault(require("./helpers/getucnid"));

/**
 * Given a url, parses the url to retrieve the context, then manually delete the context
 * @param {string} url - the url associated with the context (optional; if not specified, detected from browser)
 * @param {string} accessToken - the access token of the user
 * @returns {object} deletion status, context id, and the error if it fails.
 */
var clearContext = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var url, accessToken, _getUcnId, ucnId, isValidUrl, status, errorToSurface;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _ref.url, accessToken = _ref.accessToken;
            _getUcnId = (0, _getucnid["default"])({
              url: url
            }), ucnId = _getUcnId.ucnId, isValidUrl = _getUcnId.isValidUrl; // If the passed in URL isn't valid, return an error.

            if (isValidUrl) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", {
              deleteSuccessful: false,
              error: {
                message: "The provided URL was not valid."
              }
            });

          case 4:
            if (ucnId) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", {
              deleteSuccessful: false,
              error: {
                message: "A UCN contextId was not found in the URL."
              }
            });

          case 6:
            _context.prev = 6;
            _context.next = 9;
            return (0, _customizr.deleteUserSettings)({
              accessToken: accessToken,
              contextId: ucnId
            });

          case 9:
            return _context.abrupt("return", {
              deleteSuccessful: true,
              contextId: ucnId
            });

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](6);
            status = _context.t0.response.status;
            errorToSurface = {
              message: "",
              serverError: _context.t0
            };
            _context.t1 = status;
            _context.next = _context.t1 === 401 ? 19 : _context.t1 === 403 ? 21 : _context.t1 === 404 ? 23 : 25;
            break;

          case 19:
            errorToSurface.message = _errormessages["default"].unauthorized;
            return _context.abrupt("break", 26);

          case 21:
            errorToSurface.message = _errormessages["default"].forbidden["delete"];
            return _context.abrupt("break", 26);

          case 23:
            errorToSurface.message = _errormessages["default"].notFound;
            return _context.abrupt("break", 26);

          case 25:
            errorToSurface.message = "".concat(_errormessages["default"].serviceError["delete"], " ").concat(_errormessages["default"].contactMessage);

          case 26:
            return _context.abrupt("return", {
              deleteSuccessful: false,
              contextId: ucnId,
              error: errorToSurface
            });

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 12]]);
  }));

  return function clearContext(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _default = clearContext;
exports["default"] = _default;